// extracted by mini-css-extract-plugin
export default {"fullWidth":"fn-z","image":"gn-z","lazyLoadPicture":"hn-z","lazyLoadSpinner":"in-z","lazyLoadSpin":"jn-z","lazyLoadImage":"kn-z","hasStyledAspectRatio":"ln-z"};